import { CENTRAL_INSTANCE_LOGIN_LICENSE_NAME, CENTRAL_INSTANCE_ADMIN_LICENSE_NAME, } from '../../../constants';
import { getCombinedToken as getAccessToken, isLoggedInWithBentleyToken, } from '../../../store/sessionStorageHelpers/accessTokenHelper/accessTokenHelper';
import { setLicenseToken } from '../../../store/sessionStorageHelpers/entitlementsHelper/entitlementsHelper';
import { EntitlementsApiClient } from '../../entitlementsClient/EntitlementsApiClient';
import { AuthenticatedIdentityApiClient } from '../AuthenticatedIdentityApiClient';
const createLicenseTokenApi = (apiClient, urlPrefix) => apiClient.injectEndpoints({
    endpoints: (build) => ({
        licenseToken: build.mutation({
            query: (entitlementId) => ({
                url: `${urlPrefix}/authz/entitlements/${entitlementId}.jwt?${CENTRAL_INSTANCE_LOGIN_LICENSE_NAME}&${CENTRAL_INSTANCE_ADMIN_LICENSE_NAME}&consumptionMode=checkout&doConsume=False`,
                responseHandler: (response) => response.text().then((s) => {
                    var _a;
                    const token = s.trimStart().trimEnd();
                    if (!token.length) {
                        throw new Error('CORS failure');
                    }
                    if (response.status === 200) {
                        if (isLoggedInWithBentleyToken()) {
                            setLicenseToken(`${(_a = getAccessToken()) === null || _a === void 0 ? void 0 : _a.access_token}`);
                        }
                        else {
                            setLicenseToken(token);
                        }
                    }
                    return { data: token };
                }),
            }),
        }),
    }),
});
export const CentralSeequentLicenseTokenApi = createLicenseTokenApi(AuthenticatedIdentityApiClient, '');
export const CentralBentleyLicenseTokenApi = createLicenseTokenApi(EntitlementsApiClient, '/v1/licenses/id/central');
export const { useLicenseTokenMutation: useCentralSeequentLicenseTokenMutation } = CentralSeequentLicenseTokenApi;
export const { useLicenseTokenMutation: useCentralBentleyLicenseTokenMutation } = CentralBentleyLicenseTokenApi;
//# sourceMappingURL=CentralLicenseTokenApi.js.map